
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.108 4.776L15.4 7.361a1.613 1.613 0 001.036.77l2.338.385c1.494.247 1.842 1.329.77 2.411l-1.825 1.824a1.583 1.583 0 00-.376 1.329l.522 2.255c.413 1.778-.541 2.475-2.108 1.54l-2.191-1.3a1.556 1.556 0 00-1.448 0l-2.191 1.3c-1.568.926-2.521.238-2.108-1.54l.523-2.255a1.6 1.6 0 00-.376-1.329l-1.824-1.827c-1.073-1.07-.723-2.151.77-2.408l2.337-.385a1.583 1.583 0 001.036-.77l1.293-2.585c.687-1.403 1.824-1.403 2.53 0z","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M7.333 4.583h-5.5M4.583 17.417h-2.75M2.75 11h-.917","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","opacity":".4"}})])
          )
        }
      }
    